import { CURRENT_VIEW } from "../action/Action";

const initialState = 'grid'

const changeViewReducer = (state = initialState, action) => {
    switch (action?.type) {
        case CURRENT_VIEW:
            return {
                ...state,
                current_view: action?.payload
            };
        default: return state;
    }

}

export default changeViewReducer;